module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/ST-4e5dc435809e4a629b873c0d617a6d87.png";